<template>
  <div class="midia-fullscreen-view-container d-flex align-center justify-center">
    <div class="d-flex flex-column align-center justify-center">
      <div class="wrapper-card bg-default d-flex flex-column align-center justify-center">
        <div class="header-wrapper" style="width: 100%">
          <header
            v-if="showHeader"
            class="d-flex flex-wrap-1 align-center justify-center px-2"
          >
            <div class="d-flex align-center">
              <span
                class="text-uppercase ml-2 user-name text-h4"
                style="font-size: 1.5rem; font-weight: 500; text-transform: none !important;"
              >
                {{ headerText }}<template v-if="complemento"> - {{ complemento }}</template>
              </span>
            </div>
          </header>
        </div>
        <img
          v-if="midiaType === 'image'"
          :src="midiaUrl"
          :style="midiaStyle"
          class="my-1 media-image"
        />
        <video
          v-else-if="midiaType === 'video'"
          autoplay
          :key="midiaUrl"
          :style="midiaStyle"
          class="my-1 media-video"
        >
          <source :src="midiaUrl" />
        </video>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MidiaFullscreenView',
  props: {
    headerText: {
      type: String,
      default: '',
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    complemento: {
      type: String,
      default: '',
    },
    midiaType: {
      type: String,
      required: true,
      validator: (value) => ['image', 'video'].includes(value),
    },
    midiaUrl: {
      type: String,
      required: true,
    },
    midiaStyle: {
      type: String,
      default: '',
    },
    colors: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    backgroundColor() {
      return this.colors.backgroundColor || '#ED4619';
    },
    backgroundColorEnd() {
      return this.colors.backgroundColorEnd || '#2C172C';
    },
    backgroundGradient() {
      return `linear-gradient(to bottom, ${this.backgroundColor}, ${this.backgroundColorEnd})`;
    },
    secondaryColor() {
      return this.colors.secondaryColor || '#DDDCDC';
    },
  },
};
</script>

<style lang="scss" scoped>
.midia-fullscreen-view-container {
  width: 100%;
  overflow: hidden;
}

.wrapper-card {
  padding: 5px;
  border-radius: 10px 10px 0 0;
  box-shadow: inset 0 40px 10px -25px v-bind(backgroundColor);
  overflow: hidden;
}

.header-wrapper {
  border-radius: 10px 10px 0 0;
}

.bg-default {
  background: v-bind(backgroundGradient);
}

.user-name {
  text-transform: none !important;
  font-family: 'ZuumeEdge', sans-serif !important;
  font-style: italic !important;
  font-weight: bold !important;
  text-shadow: 0 1.5px 0 rgba(0, 0, 0, 0.3);
  color: v-bind(secondaryColor);
}

.media-image,
.media-video {
  justify-self: center;
  object-fit: contain;
}

header {
  width: 100%;
  background-color: transparent;
}
</style>
